import { useState } from "react";
import Select from "@mui/material/Select";
import { MenuItem, TextField } from "@mui/material";
import { storageProviders, storageTypes } from "../../Utils/storageTypes";
import validator from "shared/dist/utils/validator";
import "./styles.css";

const StorageTypeSelecting = ({ storageProvider, setStorageType, setLighthouseToken }) => {
    const [selectedStorageType, setSelectedStorageType] = useState(
        storageProvider ? storageProvider : storageTypes[0].id
    );
    const [lighthouseToken, setLocalLighthouseToken] = useState("");
    const [lighthouseTokenError, setLighthouseTokenError] = useState();

    const isSelectedFilecoin = selectedStorageType === storageProviders.FILECOIN;

    const handleChange = (event) => {
        const targetStorageType = event.target.value;
        setSelectedStorageType(targetStorageType);
        setStorageType(event);
        if (targetStorageType !== storageProviders.FILECOIN) {
            setLocalLighthouseToken(null);
        }
    };

    const handleToken = (event) => {
        const token = event.target?.value;
        const invalidMessage = validator.single(token, { validLighthouseToken: true });
        setLighthouseTokenError(invalidMessage);
        setLocalLighthouseToken(token);
        if (!invalidMessage) {
            setLighthouseToken(event);
        }
    };

    return (
        <div className="storage-type-container">
            <h3>Choose storage type:</h3>
            <Select
                labelId="storage-type"
                id="storage-type"
                name="storageProvider"
                value={selectedStorageType}
                MenuProps={{ disableScrollLock: true }}
                onChange={(e) => handleChange(e)}
                className="storage-type-select"
            >
                {storageTypes.map((storageType) => (
                    <MenuItem key={storageType.id} value={storageType.id}>
                        {storageType.label}
                    </MenuItem>
                ))}
            </Select>
            {isSelectedFilecoin && (
                <div className={`storage-type-token-input ${!isSelectedFilecoin && "hidden"}`}>
                    <TextField
                        id="lighthouse-token"
                        label="Lighthouse token"
                        type="text"
                        name="lighthouseToken"
                        margin="normal"
                        variant="outlined"
                        value={lighthouseToken}
                        onChange={(e) => handleToken(e)}
                        error={!!lighthouseTokenError}
                        helperText={lighthouseTokenError}
                    />
                </div>
            )}
        </div>
    );
};

export default StorageTypeSelecting;
